import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddUserGroupComponent } from './add-user-group.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ControlDisabledDirectiveModule } from 'src/app/libs/ui/directives/control-disabled/control-disabled-directive.module';
import { SharedLayoutModule } from 'src/app/shared-layout/shared-layout.module';
import { WithTooltipModule } from 'src/app/shared-layout/Components/with-tooltip/with-tooltip.module';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [AddUserGroupComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    ControlDisabledDirectiveModule,
    SharedLayoutModule,
    WithTooltipModule,
    TranslateModule
  ],
  exports: [AddUserGroupComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ]
})
export class AddUserGroupModule {}
